import { Box, Stack, Typography } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import { useAuth0 } from "@auth0/auth0-react";

export default function Unauthorized() {
  const { logout } = useAuth0();

  const handleUserLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Box
      role="main"
      aria-labelledby="unauthorized-title"
      sx={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        bgcolor: "background.default",
        px: 2,
        textAlign: "center",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <WarningIcon sx={{ fontSize: 65, color: "#F9A63A", width: "44px", height: "38px" }}
          aria-hidden >
        </WarningIcon>
        <Typography
          id="unauthorized-title"
          sx={{
            color: "#021227",
            textAlign: "center",
            fontFamily: "Nunito Sans",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >Access Denied</Typography>

        <Typography
          sx={{
            color: "#021227",
            textAlign: "center",
            fontFamily: "Nunito Sans",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            letterSpacing: "0.15px",
            maxWidth: "25rem",
          }}
        >
          You don’t have permission to view this page. Please Contact Admin to request access.
        </Typography>

        <Typography
          component="button"
          onClick={handleUserLogout}
          sx={{
            mt: 1,
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#005BFF",
            fontFamily: "Nunito Sans",
            fontSize: "14px",
            fontWeight: 600,
            letterSpacing: "0.2px",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#003EA8",
            },
          }}
        >
          Logout
        </Typography>

      </Stack>
    </Box>
  );
}